import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { CouponFormValues } from 'src/models/Coupon.model';
import CouponForm from '../Layouts/CouponForm';
import { useAddCouponMutation } from 'src/services/CouponServices';
import { showToast } from 'src/utils/showToaster';
import moment from 'moment';
type Props = {
    onClose: () => void;
};

const AddCouponFormWrapper = ({ onClose }: Props) => {

    const [addCoupon] = useAddCouponMutation()

    // Form Initial Values
    const initialValues: CouponFormValues = {
        coupon_code: '',
        vaild_from: moment() || null ,
        valid_till:  moment().add(1, 'days') || null,
        max_apply_count: 0,
        Student_name: [],
        coupon_type: '',
        type: '',
        discountAmount: '',
        maxDiscountAmount: '',
        startTime:moment()  || '',
        endTime: moment() || ''
    };

    // Validation Schema
    const validationSchema = object().shape({
        coupon_code: string().required('Please enter Coupon Code'),
        coupon_type: string().required('Please enter Coupon Type'),
        type: string().required('Please Select Type'),
        discountAmount: string().test('type', '', (value, context) => {
            if (context.parent?.type === "PERCENTAGE") {
                if (Number(value) > 100 || Number(value) < 0) {
                    return context.createError({
                        message: "Cannot be greater than 100%",
                        path: context.path,
                    });
                }
                return true;
            }
            else {
                return true
            }
        }
        ).required("Please enter discount amount "),

    });

    // Handle Submit
    const handleSubmit = (
        values: CouponFormValues,
        { setSubmitting, resetForm }: FormikHelpers<CouponFormValues>
    ) => {
        const formattedValues = {
            couponCode: values?.coupon_code,
            couponType: values?.coupon_type,
            startDate: values?.vaild_from === null ? '' : values?.vaild_from,
            endDate: values?.valid_till === null ? '' : values?.valid_till,
            maxAppliedCount: values?.max_apply_count,
            amountType: values?.type,
            maxDiscountAmount: values?.maxDiscountAmount === '' ?  values?.discountAmount : values?.maxDiscountAmount,
            discountAmount: values?.discountAmount,
            student: values?.Student_name?.map((module: any) => module?.value),
            startTime: moment(values?.startTime).format("hh:mm A"),
            endTime: moment(values?.endTime).format("hh:mm A")

        }
        addCoupon(formattedValues).then((res: any) => {
            if (res?.error) {
                showToast('error', res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast('success', res?.data?.message);
                    resetForm();
                    onClose();
                } else {
                    showToast('error', res?.data?.message);
                }
            }
            setSubmitting(false);
        });
    };

    return (
        <Dialog open maxWidth='md' fullWidth>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <CouponForm formType='Add' formikProps={formikProps} onClose={onClose} />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default AddCouponFormWrapper;